/* ==========================================================================
   GLAME ÇEREZ ONAY YÖNETİMİ
   --------------------------------------------------------------------------
   - Zorunlu (teknik) çerezler dışındaki kategoriler kapalı başlar; ziyaretçi
     seçim yapmadan hiçbir kategoriye onay verilmiş sayılmaz.
   - Seçim, sürüm ve zaman damgasıyla birlikte birinci taraf çerezde saklanır.
   - Onay, Shopify Customer Privacy API'sine iletilir; Shopify pikselleri ve
     onay API'sini kullanan uygulamalar buna göre davranır.
   - Tercihler her zaman yeniden açılabilir: GlameCookieConsent.open()

   Dışa açık API:
     GlameCookieConsent.open()            -> kişiselleştirme panelini açar
     GlameCookieConsent.get()             -> { version, timestamp, categories }
     GlameCookieConsent.allows('analytics')
     GlameCookieConsent.reset()           -> kaydı siler, bandı tekrar gösterir

   DOM olayı:
     'glame:cookie-consent' -> detail: { categories, timestamp, version, source }
   ========================================================================== */

(function () {
  'use strict';

  var COOKIE_NAME = 'glame_cookie_consent';
  var COOKIE_DAYS = 365;
  // Metin veya kategori seti değişirse sürümü artırın: eski onaylar yenilenir.
  var CONSENT_VERSION = '2026-08-13';
  var CATEGORIES = ['analytics', 'preferences', 'marketing'];

  var root = document.querySelector('[data-cookie-consent]');
  if (!root) return;

  var banner = root.querySelector('[data-cc-banner]');
  var modal = root.querySelector('[data-cc-modal]');
  var lastFocused = null;

  /* ----------------------------------------------------------------- çerez */

  function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + ';expires=' + expires + ';path=/;SameSite=Lax';
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function loadConsent() {
    var raw = readCookie(COOKIE_NAME);
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.version !== CONSENT_VERSION) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function saveConsent(categories, source) {
    var record = {
      version: CONSENT_VERSION,
      timestamp: new Date().toISOString(),
      categories: categories
    };
    writeCookie(COOKIE_NAME, JSON.stringify(record), COOKIE_DAYS);
    applyToShopify(categories);
    document.dispatchEvent(
      new CustomEvent('glame:cookie-consent', {
        detail: {
          categories: categories,
          timestamp: record.timestamp,
          version: record.version,
          source: source || 'user'
        }
      })
    );
    return record;
  }

  /* --------------------------------------------- Shopify Customer Privacy */

  function setTrackingConsent(categories) {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.setTrackingConsent !== 'function') return;
    api.setTrackingConsent(
      {
        analytics: !!categories.analytics,
        preferences: !!categories.preferences,
        marketing: !!categories.marketing,
        sale_of_data: !!categories.marketing
      },
      function () {}
    );
  }

  function applyToShopify(categories) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      setTrackingConsent(categories);
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (!error) setTrackingConsent(categories);
        }
      );
    }
  }

  /* ------------------------------------------------------------- arayüz */

  function allOff() {
    return CATEGORIES.reduce(function (acc, key) {
      acc[key] = false;
      return acc;
    }, {});
  }

  function allOn() {
    return CATEGORIES.reduce(function (acc, key) {
      acc[key] = true;
      return acc;
    }, {});
  }

  function readToggles() {
    return CATEGORIES.reduce(function (acc, key) {
      var input = root.querySelector('[data-cc-category="' + key + '"]');
      acc[key] = input ? !!input.checked : false;
      return acc;
    }, {});
  }

  function writeToggles(categories) {
    CATEGORIES.forEach(function (key) {
      var input = root.querySelector('[data-cc-category="' + key + '"]');
      if (input) input.checked = !!categories[key];
    });
  }

  function showBanner() {
    root.hidden = false;
    if (banner) banner.hidden = false;
  }

  function hideBanner() {
    if (banner) banner.hidden = true;
    if (!modal || modal.hidden) root.hidden = true;
  }

  function openModal() {
    if (!modal) return;
    lastFocused = document.activeElement;
    root.hidden = false;
    modal.hidden = false;
    var stored = loadConsent();
    // Kayıt yoksa zorunlu dışındaki her şey kapalı gelir
    writeToggles(stored ? stored.categories : allOff());
    var closeBtn = modal.querySelector('[data-cc-action="close"]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    // Henüz seçim yapılmadıysa ilk katman görünmeye devam eder
    if (!loadConsent()) {
      showBanner();
    } else {
      root.hidden = true;
    }
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function finish(categories, source) {
    saveConsent(categories, source);
    writeToggles(categories);
    if (modal) modal.hidden = true;
    hideBanner();
    root.hidden = true;
  }

  /* -------------------------------------------------------------- olaylar */

  root.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cc-action]');
    if (!trigger) {
      // Kişiselleştirme panelinin dışına tıklama
      if (modal && !modal.hidden && event.target === modal) closeModal();
      return;
    }
    event.preventDefault();

    switch (trigger.getAttribute('data-cc-action')) {
      case 'accept-all':
        finish(allOn(), 'accept-all');
        break;
      case 'reject-all':
        finish(allOff(), 'reject-all');
        break;
      case 'customize':
        hideBanner();
        openModal();
        break;
      case 'save':
        finish(readToggles(), 'save');
        break;
      case 'close':
        closeModal();
        break;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
  });

  // Footer'daki "Çerez Tercihleri" gibi tetikleyiciler
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cc-open]')) {
      event.preventDefault();
      openModal();
    }
  });

  /* ---------------------------------------------------------------- açılış */

  var existing = loadConsent();
  if (existing) {
    // Kayıtlı tercihi her sayfada Shopify'a tekrar bildir
    applyToShopify(existing.categories);
    writeToggles(existing.categories);
  } else {
    // Seçim yapılmadan zorunlu dışındaki hiçbir kategoriye onay verilmez
    applyToShopify(allOff());
    showBanner();
  }

  window.GlameCookieConsent = {
    open: openModal,
    get: loadConsent,
    allows: function (category) {
      var stored = loadConsent();
      return !!(stored && stored.categories && stored.categories[category]);
    },
    reset: function () {
      writeCookie(COOKIE_NAME, '', -1);
      writeToggles(allOff());
      applyToShopify(allOff());
      showBanner();
    }
  };
})();
